import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const SLIDES = [
  {
    image:
      "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/banner.png",
    title: "The Difference is in the Details.",
    subtitle:
      "Every thread. Every illustration. Every feeling - deliberately chosen.",
  },
];

const QUALITY_POINTS_ROW_1 = [
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon1_mood_first_design.svg",
    title: "Mood-First Design",
    description:
      "Every design begins not with a trend, but with a feeling. We ask ourselves what does this emotion look like? before a single colour is chosen or a single line is drawn.",
  },
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon2_illustrated_with_intention.svg",
    title: "Illustrated With Intention",
    description:
      "Our prints are not mass-produced graphics. They are watercolour illustrations conceived with care, refined with obsession, and brought to life with a precision that must be seen to be believed.",
  },
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon3_pure_cotton_always.svg",
    title: "Pure Cotton. Always.",
    description:
      "Only the finest cotton earns its place in a HueHoppers garment. Extraordinarily soft against skin. Naturally breathable through every escapade. And engineered with quiet confidence to hold its form wash after wash, mood after mood.",
  },
];

const QUALITY_POINTS_ROW_2 = [
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon4_gentle_on_delicate_skin.svg",
    title: "Gentle Enough For The Tiniest Skin.",
    description:
      "Our rompers are crafted from an exceptionally refined cotton impossibly soft, inherently breathable, and gentle enough for the skin you would move mountains to protect.",
  },
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon5_unisex_always.svg",
    title: "Unisex. Always.",
    description:
      "Moods recognise no gender. Neither do we. Every design we create belongs to every child who feels it without condition, without exception, without compromise.",
  },
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon6_crafted_to_last.svg",
    title: "Crafted To Last.",
    description:
      "Pre-shrunk. Colour-fast. Constructed to endure a thousand washes and still feel like the very first time. Because anything worthy of your child deserves to last.",
  },
  {
    icon: "https://huehoppers.s3.ap-south-1.amazonaws.com/website-images/difference/icon7_safe_skin_tested.svg",
    title: "Safe. Skin-Tested.",
    description:
      "Every fabric selected, every ink approved, every thread commissioned with a single, unwavering priority the extraordinary sensitivity of your child's skin. Soft. Safe. Non-negotiable.",
  },
];
const TheDifference = () => {
  useEffect(() => {
    document.title = "Feel The Difference | HueHoppers – Joyful Kids' Fashion";
  }, []);
  return (
    <>
      <div className="tf-slideshow slider-home-2 slider-effect-fade position-relative">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          effect="fade"
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          speed={1000}
          pagination={{
            clickable: true,
            el: ".sw-pagination-slider",
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
          }}
          slidesPerView={1}
          className="tf-sw-slideshow"
        >
          {SLIDES.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="wrap-slider">
                <img
                  loading="lazy"
                  decoding="async"
                  src={slide.image}
                  alt={`banner-${index + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    zIndex: 0,
                    border: "2px solid white",
                  }}
                />
                <div className="box-content">
                  <div className="container">
                    <h1 className="fade-item fade-item-1  text_white">
                      {slide.title.split(" for ").map((part, i) => (
                        <span key={i}>{part}</span>
                      ))}
                    </h1>
                    <p
                      className="fade-item fade-item-2 text_white"
                      dangerouslySetInnerHTML={{ __html: slide.subtitle }}
                      style={{ display: "block" }}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Pagination dots */}
        <div className="wrap-pagination sw-absolute-2">
          <div className="container">
            <div className="sw-dots dots-fill-white justify-content-center sw-pagination-slider swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" />
          </div>
        </div>
      </div>

      <section>
        <div className="container mt-5 mb-5">
          <div className="bg_white radius-10 flat-wrap-iconbox">
            {/* Header */}
            <div className="flat-title lg">
              <span className="title fw-5 ">Quality is our priority</span>
              <div>
                <p className="sub-title text_black-2">
                  At HueHoppers, nothing is accidental. Every decision - from
                  the cotton we source to the character we illustrate - is the
                  result of relentless deliberation and an unwavering refusal to
                  settle.
                </p>
                <br />
                <p className="sub-title text_black-2">
                  This is not clothing. This is craft. And craft, done right,
                  leaves nothing to chance.
                </p>
              </div>
            </div>

            {/* Grid */}
            <div className="flat-iconbox-v3 lg">
              <div className="row g-4">
                {QUALITY_POINTS_ROW_1.map((point, index) => (
                  <div key={index} className="col-lg-4 col-md-4 col-sm-6 col-6">
                    <div className="tf-icon-box text-center">
                      <div className="icon mb_16" style={{ border: "0px" }}>
                        <img
                          src={point.icon}
                          alt={point.title}
                          style={{
                            width: 120,
                            height: 120,
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="content">
                        <div
                          className="title  mb-3"
                          style={{ marginBottom: 8, fontWeight: "normal" }}
                        >
                          {point.title}
                        </div>
                        <p
                          className="text_black-2"
                          style={{ fontSize: 14, lineHeight: 1.6 }}
                        >
                          {point.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row mt-5">
                {QUALITY_POINTS_ROW_2.map((point, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div className="tf-icon-box text-center">
                      <div className="icon mb_16" style={{ border: "0px" }}>
                        <img
                          src={point.icon}
                          alt={point.title}
                          style={{
                            width: 120,
                            height: 120,
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="content">
                        <div
                          className="title  mb-3"
                          style={{ marginBottom: 8, fontWeight: "normal" }}
                        >
                          {point.title}
                        </div>
                        <p
                          className="text_black-2"
                          style={{ fontSize: 14, lineHeight: 1.6 }}
                        >
                          {point.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TheDifference;
